import { render } from "./GuiContentTypeSelect.vue?vue&type=template&id=06bacb8e"
import script from "./GuiContentTypeSelect.vue?vue&type=script&lang=js"
export * from "./GuiContentTypeSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__